<div class="pantalla">
  <div class="zonaLogo">
    <div class="zonaLogoSlogan">
      <img class="imagen" src="./../../../assets/img/logoB.png">
      <div class="texto">Quien todo lo sabe</div>
    </div>
  </div>
  <div class="zonaLogIn">
    <div class="formulario">
      <span class="textoBienvenido"><b>Bienvenid&#64;</b></span>
      <form [formGroup]="formLogIn" (submit)="loginUser()" class="formularioF">
        <mat-form-field appearance="outline">
          <input formControlName="email" matInput required type="email">
          <mat-icon matPrefix style="color: grey;">face</mat-icon>
          <mat-label>Correo electrónico</mat-label>
          @if (formLogIn.controls['email'].hasError('required')) {
            <mat-error>Campo <strong>requerido</strong></mat-error>
          }
          @if (formLogIn.controls['email'].hasError('email')) {
            <mat-error>Correo <strong>invalido</strong></mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input id="pass" formControlName="password" matInput required type="password">
          <mat-icon matPrefix style="color: grey;">lock</mat-icon>
          @if (passwordView) {
            <mat-icon matSuffix style="color: grey;" (click)="showPassword()">visibility</mat-icon>
          }@else {
            <mat-icon matSuffix style="color: grey;" (click)="showPassword()">visibility_off</mat-icon>
          }
          <mat-label>Contraseña</mat-label>
          @if (formLogIn.controls['password'].hasError('required')) {
            <mat-error>Campo <strong>requerido</strong></mat-error>
          }
        </mat-form-field>
      
        <div class="zonaRecordarme">
          <div class="recordarme">
            <input id="remember" type="checkbox">
            <label for="remember" class="w3-letra-recordarme w3-margin-left">recordarme</label>
          </div>
          <div class="olvidoContrasena">
            <a [routerLink]="['/','forgot-password']" class="w3-letra-olvpassword w3-margin-right">
              ¿olvidaste tu contrase&ntilde;a? 
            </a>
          </div>
        </div>
        <div class="botonEntrar">
          <button class="button" type="submit"> <b>ENTRAR</b> </button>
        </div>
      </form>
    </div>
  </div>
</div>